import { find, flatMap, get } from "lodash";
import { DOCUMENTS_TYPES, INSURANCE_PLAN_PARAMS_RULES } from "utils/constants";

/**
 * Resolves the quote email document block version from the first selected
 * plan's DOCUMENTS rule (same source as sendQuote on the API).
 */
export const resolveQuoteDocumentVersion = (
  costs = [],
  { auraTerTracer = false } = {},
) => {
  if (auraTerTracer) return "AURA_TERR";

  const rules = get(costs, "0.insurancePlan.params.0.rules", []);
  const documentsRule = find(
    rules,
    ({ name }) => name === INSURANCE_PLAN_PARAMS_RULES.DOCUMENTS,
  );
  const documentsParams = flatMap(get(documentsRule, "value"), "documents");

  return (
    get(
      documentsParams.find(
        (document) =>
          get(document, "documentName") === DOCUMENTS_TYPES.QUOTE,
      ),
      "documentVersion",
    ) || "DEFAULT"
  );
};
